import React from 'react';
import { Dialog, DialogContent, Button, Typography, Box, IconButton } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';
import InstagramIcon from '@mui/icons-material/Instagram';
import CloseIcon from '@mui/icons-material/Close';
import { styles } from './MuiStyles';
import backgroundImage from '../images/background.jpg'; // Add this import

function BookPopup({ open, onClose }) {
  const handlePhoneCall = () => {
    window.location.href = 'tel:480-910-0180';
  };

  const handleInstagramMessage = () => {
    window.open('https://ig.me/m/pristine_polish_nails_1801', '_blank');
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="sm" 
      fullWidth
      PaperProps={{
        style: {
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: 'rgba(255, 240, 245, 0.8)', // Light pink with opacity
          backgroundBlendMode: 'overlay',
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={styles.bookPopupCloseButton}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <Typography variant="body1" gutterBottom sx={styles.bookPopupText}>
          To book an appointment, please call the number below or send a message on Instagram.
        </Typography>
        <Box sx={styles.bookPopupButtonContainer}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<PhoneIcon />}
            onClick={handlePhoneCall}
            sx={styles.bookPopupButton}
          >
            Call 480-910-0180
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<InstagramIcon />}
            onClick={handleInstagramMessage}
            sx={styles.bookPopupButton}
          >
            Message on Instagram
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default BookPopup;
